import { Token } from 'react-bootstrap-typeahead';
import { useField } from 'formik';
import { EditableNameInput } from '../left-menu/menu-components';
import { captureEvent } from '../../utils/analytics';
import StandardTypeahead from '../basics/StandardTypeahead';

const filterBy = (option, props) => {
  const selectedIds = props.selected.map(({ id }) => id);
  return (
    option.name.toLowerCase().indexOf(props.text) !== -1 &&
    !selectedIds.includes(option.id) // Ensure selected items not visible if name edited
  );
};

const CropVarietiesTypeahead = (props) => {
  const [, meta, helpers] = useField('cropVarieties');
  const { initialValue, value: cropVarieties } = meta;
  const { setValue } = helpers;

  const onChange = (selected) => {
    const newVarieties = selected.filter(
      ({ customOption, id }) =>
        customOption && !cropVarieties.map((v) => v.id).includes(id),
    );
    if (newVarieties.length) {
      captureEvent('crop-variety-created', { location: 'crop-settings' });
    }
    setValue(
      // Update existing crop varieties with new values
      cropVarieties
        .map((cropVariety) => {
          const selectedVariety = selected.find(
            ({ id }) => id === cropVariety.id,
          );
          if (selectedVariety && selectedVariety.name !== cropVariety.name) {
            captureEvent('crop-variety-updated');
          } else if (!selectedVariety) {
            captureEvent('crop-variety-deleted');
          }
          // Mark variety as deleted if no longer selected
          return selectedVariety || { ...cropVariety, isDeleted: true };
        })
        // Add any crop varieties not already in the list
        .concat(newVarieties),
    );
  };

  const updateCropVarietyName = (option, name) => {
    setValue(
      cropVarieties.map((variety) =>
        variety.id === option.id ? { ...variety, name } : variety,
      ),
    );
  };

  const renderToken = (option, { onRemove }, index) => (
    <Token key={index} onRemove={onRemove} option={option}>
      <EditableNameInput
        name={option.name}
        update={(name) => updateCropVarietyName(option, name)}
        onKeyDown={(e) => {
          if (e.code === 'Backspace' || e.code === 'Delete') {
            // Prevent removing the crop variety entirely
            e.stopPropagation();
          }
        }}
      />
    </Token>
  );

  return (
    <StandardTypeahead
      allowNew
      emptyLabel="Type to add variety..."
      filterBy={filterBy}
      labelKey="name"
      multiple
      newSelectionPrefix="Add variety: "
      onChange={onChange}
      options={initialValue || []}
      renderToken={renderToken}
      selected={cropVarieties?.filter(({ isDeleted }) => !isDeleted) || []}
      size="sm"
      {...props}
    />
  );
};

export default CropVarietiesTypeahead;
